/**
 * Derive a download-safe base filename (no extension) from a widget title:
 * spaces → "_", filesystem-unsafe characters stripped, "export" fallback for
 * untitled widgets. Shared by the individual image/CSV exports and the
 * dashboard zip export so every producer names files the same way.
 */
export const toExportFilename = (title?: string): string =>
  (title || 'export')
    .trim()
    .replace(/[\\/:*?"<>|]/g, '')
    .replace(/\s+/g, '_') || 'export';
